import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { BehaviorSubject, map } from 'rxjs';
import { convertToBehaviorSubject } from '@core/shared/utils';
export class MembershipPluginsService {
  constructor(config, injector, plugins) {
    this.config = config;
    this.injector = injector;
    this.allPlugins$ = new BehaviorSubject([]);
    this.activateablePlugins$ = convertToBehaviorSubject(null)(this.allPlugins$.pipe(map(allPlugins => {
      let activateablePlugins = allPlugins.filter(p => this.activateablePluginIds && this.activateablePluginIds.includes(p.getInfo().id));
      const enablePayment = this.config.get('membership.enablePayment', 0);
      if (!enablePayment) {
        activateablePlugins = activateablePlugins.filter(ctor => ctor.getInfo().paymentRequired === false);
      }
      // console.log('all / activateablePlugins: ',allPlugins, this.activateablePluginIds,enablePayment,activateablePlugins)
      return activateablePlugins;
    })));
    this.cache = new Map();
    this.activateablePluginIds = this.config.get('membership.activateablePluginIds', null);
    if (!Array.isArray(this.activateablePluginIds)) {
      throw new Error('MembershipSystem configuration missing: membership.activateablePluginIds config must be set!');
    }
    if (!IS_PRODUCTION && this.activateablePluginIds.length === 0) {
      console.warn("MembershipSystem configuration warning: membership.activateablePluginIds is empty. This might be a mistake.");
    }
    if (!IS_PRODUCTION) {
      setTimeout(() => {
        if (!this.initialized) {
          console.error('Misconfiguration detected: MembershipPluginsService.initialize MUST be called when application bootstrapping is complete.');
        }
      }, 10000);
    }
    this.allPlugins$.next(plugins);
  }
  initialize() {
    var _this = this;
    return _asyncToGenerator(function* () {
      // creating plugin instances is not possible at construction time cause it is too early to work with the app & these classes have no lifecycle hooks.
      // thus, a separated initialize method was implemented and needs to be called from an injected child class or other lifecycle hook.
      _this.initialized = true;
      yield _this.instancePlugins();
    })();
  }
  getPluginCtor(id, includeDisabled = false) {
    const plugins = includeDisabled ? this.allPlugins$.getValue() : this.activateablePlugins$.getValue();
    return plugins.find(ctor => ctor.getInfo().id === id);
  }
  instancePlugins() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      _this2.allPlugins$.getValue().forEach(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (pluginCtor) {
          const instance = yield _this2.injector.create(pluginCtor);
          _this2.cache.set(pluginCtor.getInfo().id, instance);
        });
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    })();
  }
  getPluginInstance(id, includeDisabled = false) {
    if (this.cache.has(id)) return this.cache.get(id);
    throw new Error('plugin ' + id + ' is unknown or was requested before instanciated!');
  }
  getPluginInfo(id) {
    const pluginCtor = this.getPluginCtor(id, true);
    return pluginCtor ? pluginCtor.getInfo() : null;
  }
  getPluginsList(includeDisabled = false) {
    const source = includeDisabled ? this.allPlugins$ : this.activateablePlugins$;
    // console.log('getpluginslist',includeDisabled,source.getValue())
    return source.getValue().map(ctor => {
      return ctor.getInfo();
    });
  }
}